import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class OrganizationAssociations extends BaseModel {
  constructor() {
    super(collection(db, 'org_associations'))
  }
}
